import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { IDropdownOption } from '../../../../../shared/typings/interfaces/design-library.interface';
import { ISchoolAssessment } from '../../../../../shared/typings/interfaces/school-assessment.interface';

@Component({
  selector: 'assessments-data-input-header',
  template: require('./assessments-data-input-header.component.html'),
  styles: [require('./assessments-data-input-header.component.scss')],
})
export class AssessmentsDataInputHeaderComponent implements OnInit {
  @Input() schoolAssessment: ISchoolAssessment;
  @Input() filterForm: FormControl;
  @Input() sort$: BehaviorSubject<{ key: string; dir: string }>;
  @Input() saveButtonActive: boolean;
  @Input() showShadow: boolean;
  @Input() groupingOptions: IDropdownOption[];
  @Input() currentGroupingCount: number;
  @Input() selectedGrouping: IDropdownOption;
  @Output() changeGrouping: EventEmitter<any> = new EventEmitter();
  @Output() saveForm: EventEmitter<any> = new EventEmitter();
  @Output() onClickSortColumn: EventEmitter<string> = new EventEmitter();
  public assessmentNickName: string;
  public adminNumber: number;
  public searchIcon = 'search';
  public searchPlaceholder = 'Find a student...';
  public exitWarningTitle = 'Are you sure you want to leave the page?';
  public exitWarningMessage = 'You will lose any unsaved changes';

  constructor(@Inject('$state') private $state) {
    //
  }

  ngOnInit() {
    const {
      adminNumber,
      assessment: { assessmentNickName },
    } = this.schoolAssessment;
    this.assessmentNickName = assessmentNickName;
    this.adminNumber = adminNumber;
  }

  goBack(): void {
    this.$state.go('main.school.data-entry.assessments');
  }

  updateGrouping(optionKey: IDropdownOption['key']): void {
    const option = this._getOptionFromKey(optionKey, this.groupingOptions);
    this.changeGrouping.emit({ option, source: 'dropdown' });
  }

  clearSearchFilter(): void {
    this.filterForm.setValue('');
  }

  submitForm(): void {
    this.saveForm.emit();
  }

  sortColumnClicked(sortKey: string): void {
    this.onClickSortColumn.emit(sortKey);
  }

  // Same methods in the nv-dropdown.component.ts - jchu
  _getOptionFromKey(searchKey: string, searchOptions: IDropdownOption[]): IDropdownOption {
    let foundOption: IDropdownOption = null;
    if (!!searchKey) {
      for (const opt of searchOptions) {
        if (!!foundOption) {
          break;
        } else if (opt.options) {
          foundOption = this._getOptionFromKey(searchKey, opt.options);
        } else if (opt.key === searchKey) {
          foundOption = opt;
        }
      }
    }
    return foundOption;
  }
}
